<template>
	<div class="tBuilder gutter">
		<!-- Loading -->
		<div v-if="loading" class="loading-wrapper">
			<div v-if="!promoLoading" class="loader loader-7"></div>
			<div v-if="promoLoading" class="loading-message">
				<div class="loader loader-7"></div>
				<p>We are processing your promo code.</p>
			</div>
		</div>
		<!-- Adding tickets to cart without GA tickets warning -->
		<transition name="date-transition">
			<div v-if="precartWarning" class="precartModal">
				<div class="precartModal__wrap">
					<div @click="precartWarningToggle(false)" class="precartModal__close">
						<CloseNoGaWarning></CloseNoGaWarning>
					</div>
					<p class="precartModal__p">
						This event requires the purchases of a General Admission ticket for
						your selected day, {{ eventGaStepOneData.month }}
						{{ eventGaStepOneData.day }}. You did not select a General Admission
						ticket in your cart. If you have already purchased your tickets,
						please tick the box and continue. If not, please exit and add
						general admission tickets to your cart.
					</p>
					<div class="precartModal__checkboxDiv">
						<div
							@click="preCartWarningCheckbox = !preCartWarningCheckbox"
							:class="[
								preCartWarningCheckbox
									? 'precartModal__checkbox precartModal__checkbox--active'
									: 'precartModal__checkbox',
							]"
						>
							<PrecartModalCheck></PrecartModalCheck>
						</div>
						<p class="precartModal__p2">
							I understand this event requires the purchase of a general
							admission ticket, and I have already purchased my tickets
						</p>
					</div>
					<div class="precartModal__buttonDiv">
						<!-- if checkbox above is checked -->
						<div
							v-if="preCartWarningCheckbox"
							class="precartModal__checkoutBtn"
							@click="precartAdded"
						>
							<p>Checkout</p>
						</div>
						<!-- else -->
						<div
							v-if="!preCartWarningCheckbox"
							class="precartModal__checkoutBtn"
						>
							<p>Checkout</p>
						</div>
						<div
							@click="precartWarningToggle(false)"
							class="precartModal__addGaBtn"
						>
							<p>Add General Admission tickets</p>
							<PrecartArrow></PrecartArrow>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<!-- Modal for Events -->
		<transition name="date-transition">
			<div v-if="singleTicketModalInfo !== null" class="singleModal">
				<div class="singleModal__modalInside">
					<div
						class="singleModal__close"
						@click="closeSingleModal(singleTicketModalInfo.extendedProps.index)"
					>
						<CloseX></CloseX>
					</div>

					<!-- Modal Info -->
					<div class="singleModal__left">
						<img
							v-if="singleTicketModalInfo.extendedProps.image !== undefined"
							class="singleModal__img"
							:src="singleTicketModalInfo.extendedProps.image"
						/>
						<img
							v-if="singleTicketModalInfo.extendedProps.image === undefined"
							class="singleModal__img"
							:src="eventImage"
						/>
						<div class="singleModal__text">
							<h5 class="singleModal__h5">{{ singleTicketModalInfo.title }}</h5>
							<p class="singleModal__date">
								{{ singleTicketModalInfo.month }}
								{{ singleTicketModalInfo.day }},
								{{ singleTicketModalInfo.year }}
								{{ singleTicketModalInfo.extendedProps.time }}
							</p>
							<p
								v-if="singleTicketModalInfo.extendedProps.address === undefined"
								class="singleModal__loc"
							>
								{{ eventAddress }}
							</p>
							<p
								v-if="singleTicketModalInfo.extendedProps.link !== undefined"
								class="singleModal__loc"
							>
								{{ singleTicketModalInfo.extendedProps.address }}
							</p>

							<div
								v-if="singleTicketModalInfo.extendedProps.desc !== null"
								class="singleModal__desc"
								v-html="singleTicketModalInfo.extendedProps.desc"
							></div>

							<p class="singleModal__link">
								<a
									v-if="singleTicketModalInfo.extendedProps.link !== undefined"
									target="_blank"
									:href="singleTicketModalInfo.extendedProps.link"
									>Learn more</a
								>
								<a
									v-if="singleTicketModalInfo.extendedProps.link === undefined"
									target="_blank"
									:href="eventLink"
									>Learn more</a
								>
							</p>
						</div>
					</div>

					<!-- Modal Tickets -->
					<div class="singleModal__right">
						<div v-if="modalTicketsRendering" class="loading-wrapper">
							<div class="loader loader-7"></div>
						</div>
						<div
							v-if="singleTicketModalInfo.extendedProps.gaRequired"
							class="singleModal__gaRequiredDiv"
						>
							<p class="singleModal__gaRequiredP">
								This event is
								<span>included with a General Admission ticket.</span>
							</p>
							<p class="singleModal__gaRequiredP">
								Please choose how many people will be attending the event.
							</p>
							<p class="singleModal__gaRequiredP">
								You will then be taken to purchase your museum ticket(s) and
								confirm your selection.
							</p>
						</div>
						<div v-if="singleTicketModalInfo.tickets" class="tLeft__flexUl">
							<div
								v-for="(ticket, index) in singleTicketModalInfo.tickets"
								v-bind:key="ticket.id"
								v-if="ticket.type !== undefined || ticket.mos === 3"
								:class="[ticket.count > 0 ? 'tLeft__ticketSelected' : '']"
								class="singleModal__ticket"
							>
								<div class="tLeft__tickId">
									<p class="tLeft__ticketName">{{ ticket.type }}</p>
								</div>
								<p class="tLeft__money">${{ ticket.price }}</p>
								<div class="tLeft__ticketRight">
									<div class="tLeft__calc">
										<div
											class="tLeft__ticketBtn"
											@click="removeEventTicket(index)"
										>
											<p>-</p>
										</div>
										<p class="tLeft__val">{{ ticket.count }}</p>
										<div
											class="tLeft__ticketBtn"
											@click="addEventTicket(index)"
										>
											<p>+</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="
								eventTotalTickets > 0 &&
								!singleTicketModalInfo.extendedProps.gaRequired
							"
							class="singleModal__btn"
							@click="reserveEventTickets(singleTicketModalInfo.index)"
						>
							<p>Add to cart</p>
						</div>
						<div
							v-if="
								eventTotalTickets > 0 &&
								singleTicketModalInfo.extendedProps.gaRequired
							"
							class="singleModal__btn"
							@click="eventGaStepOne(singleTicketModalInfo.index)"
						>
							<p>Continue</p>
						</div>
						<div
							v-if="eventTotalTickets === null"
							class="singleModal__btn singleModal__btn--inactive"
						>
							<p>Add to cart</p>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<!-- Notice attached to GA Package Selected Date -->
		<transition name="date-transition">
			<div v-if="gaPackageNoticeInfo !== null" class="noticeModal gutter">
				<div class="noticeModal__inside">
					<div class="noticeModal__white">
						<div class="noticeModal__top">
							<Notice />
							<p>Please note</p>
						</div>
						<div class="noticeModal__body">
							<div v-html="gaPackageNoticeInfo"></div>
						</div>
						<div class="noticeModal__btn" @click="closeGaPackageNotice">
							<p>I understand</p>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<!-- General Admission Ticket Builder -->
		<div
			class="tBuilder__contWrap"
			v-if="(singleTicketModalInfo === null && mobile) || !mobile"
		>
			<div
				:class="[
					(!cartData &&
						mobile &&
						ticketType !== 'programs' &&
						eventGaStepOneData.bool) ||
					(cartData &&
						!cartData.Products &&
						mobile &&
						ticketType !== 'programs' &&
						eventGaStepOneData.bool)
						? 'tBuilder__container  tBuilder__container--reverse'
						: 'tBuilder__container',
				]"
			>
				<div
					v-if="!mobileCartFullview"
					class="tLeft"
					:class="[ticketType === 'programs' ? 'tLeft--full' : '']"
				>
					<div class="tBuilder__topDiv">
						<h1 class="tBuilder__h1">{{ title }}</h1>
						<CartButtonMobile
							v-if="mobile && cartData && cartData.Products !== null"
							@openCart="openCart"
						></CartButtonMobile>
					</div>
					<div class="tTop">
						<p class="tTop__p">{{ intro }}</p>
					</div>

					<!-- Step One - GA or Events or Ropes Tour-->
					<div class="tLeft__type">
						<h2
							v-if="
								!cartData ||
								!cartData.Products ||
								cartData.Products.length === 0
							"
							class="tLeft__h2"
						>
							{{ stepOne }}
						</h2>
						<h2
							v-if="
								cartData && cartData.Products && cartData.Products.length > 0
							"
							class="tLeft__h2"
						>
							1. Add Another Ticket
						</h2>
						<p class="tLeft__p">
							{{ stepOneHelp }}
						</p>
						<div
							class="tLeft__flexUl"
							v-if="
								ticketType === '' ||
								ticketType === 'general-admission' ||
								ticketType === 'tour'
							"
						>
							<div
								class="tLeft__li tLeft__li--stepOne general-admission"
								:class="[isGeneralAdmission ? 'tLeft__ticketTypeSelected' : '']"
								@click="setTicketType('general-admission')"
							>
								<p class="tLeft__name">General Admission</p>
							</div>
							<div
								class="tLeft__li tLeft__li--stepOne programs"
								:class="[isPrograms ? 'tLeft__ticketTypeSelected' : '']"
								@click="setTicketType('programs')"
							>
								<div>
									<p class="tLeft__name">Events</p>
									<p class="tLeft__help">Select from calendar</p>
								</div>
								<EventsCalendarSvg></EventsCalendarSvg>
							</div>
							<div
								class="tLeft__li tLeft__li--stepOne general-admission"
								:class="[isTour ? 'tLeft__ticketTypeSelected' : '']"
								@click="setTicketType('tour')"
							>
								<p class="tLeft__name">Ropes Mansion Tour</p>
								<p class="tLeft__help">Without General Admission</p>
							</div>
						</div>
						<transition name="hardout-transition">
							<div
								v-if="ticketType === 'programs'"
								:class="[mobile ? 'tLeft__li--eventsMobile' : '']"
								class="tLeft__li tLeft__li--programs"
							>
								<p class="tLeft__name">
									<span @click="ticketType = ''" v-if="mobile"
										>Back to Events</span
									>
								</p>
								<p class="tLeft__help">Select from the calendar</p>
								<div @click="ticketType = ''" class="tLeft__closePrograms">
									<CloseX></CloseX>
								</div>

								<!-- Events -->
								<Events
									class="cal"
									v-bind:noModal="noModal"
									v-bind:eventModalIndex="eventModalIndex"
									v-bind:mobile="mobile"
									@renderModal="renderModal"
								></Events>
							</div>
						</transition>
					</div>

					<!-- if isTour -->
					<transition name="date-transition">
						<Tours
							ref="tours"
							v-bind:sessionKey="sessionKey"
							@reserveRopesOnly="reserveRopesOnly"
							v-if="ticketType === 'tour'"
						></Tours>
					</transition>
					<!-- end if isTour -->

					<!-- GA Date -->
					<transition name="date-transition">
						<div
							v-if="ticketType === 'general-admission'"
							class="tLeft__date tLeft__flexUl"
						>
							<h2 ref="step2" class="tLeft__h2">{{ stepTwo }}</h2>
							<p class="tLeft__p">
								{{ stepTwoHelp }}
							</p>

							<div
								v-if="nextAvailableDates"
								class="tLeft__li tLeft__li--stepOne"
								:class="[isDateFirstProp ? 'tLeft__dateSelected' : '']"
								@click="setDate(nextAvailableDates[0].formattedDateStr)"
							>
								<p class="tLeft__name">{{ nextAvailableDates[0].dayOfWeek }}</p>
								<p class="tLeft__help">
									{{ nextAvailableDates[0].formattedDate }}
								</p>
							</div>
							<div
								v-if="nextAvailableDates"
								class="tLeft__li tLeft__li--stepOne"
								:class="[isDateSecondProp ? 'tLeft__dateSelected' : '']"
								@click="setDate(nextAvailableDates[1].formattedDateStr)"
							>
								<p class="tLeft__name">{{ nextAvailableDates[1].dayOfWeek }}</p>
								<p class="tLeft__help">
									{{ nextAvailableDates[1].formattedDate }}
								</p>
							</div>
							<div
								v-if="!showMinical"
								class="tLeft__li tLeft__li--stepOne programs"
								@click="showMinical = true"
							>
								<div>
									<p class="tLeft__name">Choose a date</p>
									<p class="tLeft__help">Show calendar</p>
								</div>
								<EventsCalendarSvg></EventsCalendarSvg>
							</div>
							<div
								class="tLeft__li"
								v-if="showMinical"
								:class="[showMinical ? 'tLeft__showMinical' : '']"
							>
								<div
									class="tLeft__closeMinicalBtn"
									@click="showMinical = false"
								>
									<CloseX></CloseX>
								</div>
								<datepicker
									v-if="showMinical"
									class="dateItem datePick"
									v-model="date"
									:disabled-dates="this.vueDatepickerOptions[0]"
									@selected="setDate()"
									model-type="yy-m-d"
									inline
									auto-apply
								/>
							</div>
						</div>
					</transition>

					<!-- GA - Promo Code -->
					<transition name="date-transition">
						<div
							ref="step3"
							v-if="gaTicketsRendered && ticketType === 'general-admission'"
							class="tLeft__promo"
						>
							<h2 class="tLeft__h2">{{ stepThree }}</h2>
							<p class="tLeft__p">
								{{ stepThreeHelp }}
							</p>
							<div class="tLeft__form">
								<div class="tLeft__promoInputwrapper">
									<input
										type="text"
										v-model="promoCode"
										class="tLeft__promoInput"
										placeholder="Enter Promo Code"
									/>
									<button class="tLeft__promoBtn">
										<span
											class="tLeft__promoInactive"
											v-if="
												promoCode.length < 3 && gaTicketsRendered[0].id === 2
											"
											>Apply</span
										>
										<span
											class="tLeft__promoActive"
											v-if="
												promoCode.length > 2 && gaTicketsRendered[0].id === 2
											"
											@click="validatePromo"
											>Apply</span
										>
										<span
											class="tLeft__removePromo"
											v-if="gaTicketsRendered[0].id !== 2"
											@click="removePromo"
										>
											<CloseX></CloseX
										></span>
									</button>
								</div>
								<div
									v-if="gaTicketsRendered[0].id !== 2"
									class="tLeft__promocodeValidated"
								>
									<p>
										{{ gaTicketsRendered[0].title }}
										<span v-if="gaTicketsRendered[0].id !== 67">
											- {{ gaTicketsRendered[0].limit }}
											free adult
											<span v-if="gaTicketsRendered[0].limit < 2">ticket</span
											><span v-else>tickets</span></span
										>
										<span v-else
											>per ticket - limit
											{{ gaTicketsRendered[0].limit }} tickets</span
										>
									</p>
								</div>
								<div
									v-if="promoError"
									class="tLeft__promocodeValidated tLeft__promocodeValidated--false"
								>
									<p>
										It appears that the promo code entered is no longer valid.
									</p>
								</div>
							</div>
						</div>
					</transition>

					<!-- GA - Tickets -->
					<transition name="date-transition">
						<div
							class="tLeft__tickets"
							v-if="gaTicketsRendered && ticketType === 'general-admission'"
						>
							<h2 class="tLeft__h2">{{ stepFour }}</h2>
							<p class="tLeft__p">
								{{ stepFourHelp }}
							</p>
							<div class="tLeft__flexUl">
								<div
									v-for="(ticket, index) in gaTicketsRendered"
									v-bind:key="ticket.id"
									:class="[ticket.count > 0 ? 'tLeft__ticketSelected' : '']"
									class="tLeft__li tLeft__li--ticketType"
								>
									<div class="tLeft__tickId">
										<p class="tLeft__ticketName">{{ ticket.title }}</p>
										<p class="tLeft__ticketHelp">{{ ticket.helperText }}</p>
									</div>
									<div class="tLeft__rightTicketCont">
										<p class="tLeft__money">${{ ticket.price }}</p>
										<div class="tLeft__ticketRight">
											<div class="tLeft__calc">
												<div
													class="tLeft__ticketBtn"
													@click="removeTicket('gaTickets', index)"
												>
													<div v-if="ticket.count > 0">
														<MinusActive></MinusActive>
													</div>
													<div v-else><MinusInactive></MinusInactive></div>
												</div>
												<p class="tLeft__val">{{ ticket.count }}</p>
												<div
													class="tLeft__ticketBtn"
													@click="addTicket('gaTickets', index)"
												>
													<div v-if="ticket.count > 0">
														<PlusActive></PlusActive>
													</div>
													<div v-else><PlusInactive></PlusInactive></div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<p
									class="tLeft__p tLeft__p--show"
									v-if="!showLess"
									@click="showMoreTickets"
								>
									Show more ticket types
									<ShowMoreCarrot></ShowMoreCarrot>
								</p>
								<p class="tLeft__p" v-if="showLess" @click="showLessTickets">
									Show less ticket types
									<ShowMoreCarrot class="upsideDown"></ShowMoreCarrot>
								</p>
							</div>
						</div>
					</transition>

					<!-- GA - YYT & Ropes Mansion -->
					<transition name="date-transition">
						<div
							class="tLeft__yyt"
							v-if="
								totalGaTickets > 0 &&
								ticketType === 'general-admission' &&
								yyTimes !== null
							"
						>
							<div class="tLeft__step5">
								<div class="tLeft__step5left">
									<h2 class="tLeft__h2">{{ stepFive }}</h2>
									<p class="tLeft__p">
										{{ stepFiveHelp }}
									</p>
								</div>
								<div class="tLeft__step5right" @click="showYytTimes()">
									<YytCarrot
										:class="[yytTimesBool === true ? 'tLeft__step5turn' : '']"
									></YytCarrot>
								</div>
							</div>
						</div>
					</transition>

					<!--		GA - YYT -->
					<transition name="date-transition">
						<div
							v-if="
								totalGaTickets > 0 && yytTimesBool === true && yyTimes !== null
							"
						>
							<p class="tLeft__h0">Available Times</p>
							<div class="tLeft__yyTimes">
								<div
									class="tLeft__yyTime"
									:class="[
										selectedYYtime === time.id ? 'tLeft__yyTimeSelected' : '',
										selectedYYtime === null ? '' : '',
									]"
									@click="settingYYtime(index)"
									v-for="(time, index) in yyTimes"
									v-bind:key="time.id"
								>
									<p>
										{{ time.presentationTime }}
									</p>
								</div>
							</div>
						</div>
					</transition>

					<!-- GA - Ropes Mansion -->
					<transition name="date-transition">
						<div
							class="tLeft__yyt"
							v-if="
								ropesTimes !== null &&
								ticketType === 'general-admission' &&
								totalGaTickets > 0
							"
						>
							<div class="tLeft__step5">
								<div class="tLeft__step5left">
									<h2 class="tLeft__h2">{{ stepSix }}</h2>
									<p class="tLeft__p">
										{{ stepSixHelp }}
									</p>
								</div>
								<div class="tLeft__step5right" @click="showRopesTimes()">
									<YytCarrot
										:class="[ropesTimesBool === true ? 'tLeft__step5turn' : '']"
									></YytCarrot>
								</div>
							</div>
						</div>
					</transition>
					<transition name="date-transition">
						<div
							v-if="
								totalGaTickets > 0 &&
								ropesTimesBool === true &&
								ropesTimes !== null
							"
						>
							<p class="tLeft__h0">Available Times</p>
							<div class="tLeft__yyTimes">
								<div
									class="tLeft__yyTime"
									:class="[
										selectedRopesTime === time.id
											? 'tLeft__yyTimeSelected'
											: '',
										selectedRopesTime === null ? '' : '',
									]"
									@click="settingRopesTime(index)"
									v-for="(time, index) in ropesTimes"
									v-bind:key="time.id"
								>
									<p>
										{{ time.presentationTime }}
									</p>
								</div>
							</div>
						</div>
					</transition>
					<transition name="date-transition">
						<div
							class="tLeft__tickets"
							v-if="
								formattedDate.length > 0 &&
								eventGaStepOneData.date &&
								eventGaStepOneData.date.split('T')[0] === formattedDate &&
								eventGaStepOneData.eventId &&
								totalGaTickets
							"
						>
							<h2 class="tLeft__h2">
								<span v-if="ropesTimes === null">5.</span>
								<span v-if="ropesTimes !== null">6.</span>
								{{ eventGaStepOneData.title }}
							</h2>
							<p class="tLeft__p">This event is included with admission</p>
							<p class="tLeft__p2">Select number of attendees:</p>
							<transition name="date-transition">
								<div v-if="eventGaTicketWarning" class="tLeft__eventGaWarning">
									<EventWithGaWarning></EventWithGaWarning>
									<div class="tLeft__eventGaWarningMore">
										<p
											v-if="eventGaTicketWarningText"
											class="tLeft__eventGaWarningMore"
										>
											This event requires a general admission ticket for each
											participant. Please match the number of general admission
											tickets to the number of event tickets.
										</p>
										<p
											v-if="eventGaOutOfTickets"
											class="tLeft__eventGaWarningMore"
										>
											There are
											<span class="tLeft__eventGaWarningMore--b"
												>{{ eventGaOutOfTickets }} spots left</span
											>
											for this event. More tickets cannot be added at this time.
										</p>
									</div>
								</div>
							</transition>
							<div
								v-if="eventGaStepOneData.tickets !== null"
								class="tLeft__flexUl tLeft__flexUl--gaEvent"
							>
								<div
									v-for="(ticket, index) in eventGaStepOneData.ticketsActive"
									v-bind:key="ticket.id"
									:class="[ticket.count > 0 ? 'tLeft__ticketSelected' : '']"
									class="tLeft__li tLeft__li--ticketType"
								>
									<!-- <div v-if="eventGaStepOneData.tickets[index].count > 0"> -->
									<div class="tLeft__tickId">
										<p class="tLeft__ticketName">{{ ticket.type }}</p>
										<!-- <p class="tLeft__ticketHelp">{{ ticket.helperText }}</p> -->
									</div>
									<div class="tLeft__rightTicketCont">
										<p class="tLeft__money">${{ ticket.price }}</p>
										<div class="tLeft__ticketRight">
											<div class="tLeft__calc">
												<div
													class="tLeft__ticketBtn"
													@click="removeTicket('gaEvents', index)"
												>
													<div v-if="ticket.count > 0">
														<MinusActive></MinusActive>
													</div>
													<div v-else><MinusInactive></MinusInactive></div>
												</div>
												<p class="tLeft__val">{{ ticket.count }}</p>
												<div
													class="tLeft__ticketBtn"
													@click="addTicket('gaEvents', index)"
												>
													<div v-if="ticket.count > 0">
														<PlusActive></PlusActive>
													</div>
													<div v-else><PlusInactive></PlusInactive></div>
												</div>
											</div>
										</div>
									</div>
									<!-- </div> -->
								</div>
							</div>
						</div>
					</transition>

					<!-- GA - Add to Cart -->
					<transition name="date-transition">
						<div v-if="totalGaTickets > 0" class="tLeft__addTickets">
							<button class="tLeft__addTicketsBtn" @click="addGaTicketsToCart">
								<p>Add to Cart</p>
							</button>
						</div>
					</transition>
				</div>

				<!-- Cart -->
				<transition name="hardout-transition">
					<Cart
						v-bind:checkoutUrl="checkoutUrl"
						v-bind:redirectUrl="redirectUrl"
						v-bind:cartData="cartData"
						v-bind:sessionKey="sessionKey"
						v-bind:eventGaStepOneData="eventGaStepOneData"
						v-bind:cart="cart"
						v:bind:loading="loading"
						v-bind:mobile="mobile"
						v-bind:ticketAdded="ticketAdded"
						@cartEditSetLoading="cartEditSetLoading"
						@falseTicketAdded="falseTicketAdded"
						@updateCart="updateCart"
						@updatePackage="updatePackage"
						@cookieCartUpdate="cookieCartUpdate"
						@cookieCartEventUpdate="cookieCartEventUpdate"
						@renderModal="renderModal"
						@precartWarningToggle="precartWarningToggle"
						@precartAdded="precartAdded"
						@openRopes="openRopes"
						class="cart"
						v-if="
							(cartData &&
								ticketType !== 'programs' &&
								mobileCartFullview &&
								mobile) ||
							(cartData &&
								cartData.Products &&
								ticketType !== 'programs' &&
								!mobile) ||
							(!cartData &&
								ticketType !== 'programs' &&
								eventGaStepOneData.bool) ||
							(cartData && ticketType !== 'programs' && eventGaStepOneData.bool)
						"
					></Cart>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Cart from './Cart';
import Events from './Events';
import Tours from './Tour';
import CartButtonMobile from './svg/CartButtonMobile';
import CloseX from './svg/CloseX';
import EventsCalendarSvg from './svg/EventsCalendarSvg';
import ShowMoreCarrot from './svg/ShowMoreCarrot';
import YytCarrot from './svg/YytCarrot';
import Notice from './svg/Notice';
import MinusActive from './svg/MinusActive';
import MinusInactive from './svg/MinusInactive';
import PlusActive from './svg/PlusActive';
import PlusInactive from './svg/PlusInactive';
import CloseNoGaWarning from './svg/CloseNoGaWarning';
import PrecartArrow from './svg/PrecartArrow';
import PrecartModalCheck from './svg/PrecartModalCheck';
import EventWithGaWarning from './svg/EventWithGaWarning';
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
// Vue.component('v-select', vSelect);
var Vue = require('vue');
Vue.use(require('vue-cookies'));

export default {
	name: 'Ticketing',

	props: {
		daysNotOpenProp: String,
		checkoutUrl: String,
		redirectUrl: String,
		title: String,
		intro: String,
		stepOne: String,
		stepOneHelp: String,
		stepTwo: String,
		stepTwoHelp: String,
		stepThree: String,
		stepThreeHelp: String,
		stepFour: String,
		stepFourHelp: String,
		stepFive: String,
		stepFiveHelp: String,
		stepFiveNotAvailable: String,
		stepSix: String,
		stepSixHelp: String,
		eventAddress: String,
		eventImage: String,
		eventLink: String,
	},
	components: {
		Datepicker,
		Cart,
		Events,
		Tours,
		EventWithGaWarning,
		CartButtonMobile,
		CloseX,
		EventsCalendarSvg,
		Notice,
		ShowMoreCarrot,
		YytCarrot,
		PlusActive,
		PlusInactive,
		MinusActive,
		MinusInactive,
		PrecartArrow,
		CloseNoGaWarning,
		PrecartModalCheck,
		'v-select': vSelect,
	},
	data() {
		return {
			noModal: false,
			loading: false,
			promoLoading: false,
			sessionKey: null,
			sessionTime: null,
			nfsPackageLineItemId: null,
			gaPerformanceId: null,
			gaPackageId: null,
			gaZoneId: null,
			singleTicketModalInfo: null,
			gaPerformanceGroupId: null,
			yytPerformanceGroupId: null,
			yytPerformanceId: null,
			yytAllZones: null,
			priceTypes: null,
			ropesPriceTypes: null,
			sourceId: null,
			appealId: null,
			promoCode: '',
			ticketType: '',
			promoCodeValidated: false,
			promoId: null,
			promoError: false,
			selectedYYtime: null,
			totalGaTickets: null,
			date: '',
			todayInactive: false,
			showMinical: false,
			showLess: false,
			gaTickets: null,
			gaTicketsRendered: null,
			gaPackageNoticeInfo: null,
			packageNote: null,
			yyTimes: null,
			yytTimesBool: true,
			ropesTimesBool: true,
			ropesPerformanceGroupId: null,
			ropesPerformanceId: null,
			ropesAllZones: null,
			ropesTimes: null,
			eventModalIndex: null,
			event: null,
			eventTicketInfo: null,
			eventPriceTypes: null,
			eventTotalTickets: null,
			selectedRopesTime: null,
			cart: [],
			monthNames: [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			],
			gaRenderedPriceTypes: null,
			gaAllowedPriceTypes: [2, 11, 10, 152, 6, 7, 9, 129, 125, 159],
			gaTicketTextInfo: null,
			filteredCart: null,
			cartData: null,
			nextAvailableDates: null,
			firstDateValue: null,
			firstDateText: null,
			secondDateValue: null,
			secondDateText: null,
			daysNotOpen: [],
			vueDatepickerOptions: [
				{
					to: new Date(),
					from: new Date(2025, 6, 0o1),
					days: [2, 3],
					dates: [
						new Date(2026, 12, 25),
						new Date(2024, 12, 25),
						new Date(2025, 12, 25),
						new Date(2026, 1, 1),
						new Date(2025, 1, 1),
						new Date(2026, 1, 1),
					],
				},
			],
			mobile: false,
			ticketAdded: false,
			eventGaAllTickets: null,
			eventGaStepOneData: {
				eventId: null,
				sessionKey: null,
				totalTickets: null,
				priceTypes: null,
				zoneId: null,
				month: null,
				day: null,
				year: null,
				time: null,
				tickets: null,
				allTickets: null,
				title: null,
				date: null,
				bool: null,
				pricesAdded: false,
				ticketsAvailable: null,
				ticketsActive: null,
			},
			precartWarning: false,
			preCartWarningCheckbox: false,
			eventGaTicketWarning: false,
			eventGaTicketWarningText: '',
			eventGaOutOfTickets: '',
		};
	},

	computed: {
		mobileCartFullview() {
			if (this.ticketAdded && this.mobile) {
				return true;
			}
			return false;
		},
		formattedDate(date) {
			if (this.date === '') {
				return '';
			}
			var d = new Date(this.date);
			return [
				d.getFullYear(),
				('0' + (d.getMonth() + 1)).slice(-2),
				('0' + d.getDate()).slice(-2),
			].join('-');
		},
		isDateFirstProp() {
			if (this.date === '') {
				return;
			}
			return this.date == this.nextAvailableDates[0].formattedDateStr;
		},
		isDateSecondProp() {
			if (this.date === '') {
				return;
			}
			return this.date == this.nextAvailableDates[1].formattedDateStr;
		},
		isGeneralAdmission() {
			return this.ticketType == 'general-admission';
		},
		isPrograms() {
			return this.ticketType == 'programs';
		},
		isTour() {
			return this.ticketType == 'tour';
		},
	},

	methods: {
		openRopes() {
			this.ticketType = 'tour';
		},
		updateDropDownValues(countNew) {
			if (countNew) {
				this.dropDownValues = Array.from({ length: countNew + 1 }, (v, k) => k);
			}
		},
		setValuesToNull(object) {
			Object.keys(object).forEach((key) => {
				this.$set(object, key, null);
			});
		},
		precartWarningToggle(bool) {
			this.precartWarning = !this.precartWarning;
			if (bool === true) {
				this.eventGaStepOneData.pricesAdded = true;
				this.ticketType = 'general-admission';
				this.showMinical = true;
				this.date = this.eventGaStepOneData.date;
				if (this.mobile) {
					$('html,body').scrollTop(0);
				}
			}
		},
		precartAdded() {
			let that = this;
			$.get(
				'/actions/my-module/default/reserve-event-tickets',
				{
					eventId: that.eventGaStepOneData.eventId,
					session: that.sessionKey,
					totalTickets: that.eventGaStepOneData.totalTickets,
					priceTypes: that.eventGaStepOneData.priceTypes,
					zoneId: that.eventGaStepOneData.zoneId,
				},
				function (res) {
					let jsonRes = JSON.parse(res);
					Vue.set(that.event, 'lineItemId', jsonRes.LineItemId);
				}
			)
				.done(function () {
					$.get(
						'/actions/my-module/default/get-cart-details',
						{ session: that.sessionKey },
						function (res) {
							let jsonData = JSON.parse(res);
							that.cartData = jsonData;
							if (that.mobile && that.cartData) {
								that.ticketAdded = true;
							}
						}
					);
				})
				.done(function () {
					let cartObj = {
						event: that.event,
					};
					that.cart.push(cartObj);
					let inFifteenMinutes = new Date(
						new Date().getTime() + 20 * 60 * 1000
					);

					inFifteenMinutes = inFifteenMinutes.toUTCString();
					that.$cookies.set(that.sessionKey, JSON.stringify(that.cart), {
						expires: inFifteenMinutes,
					});
					let sessionCookie = that.$cookies.get(that.sessionKey);
					that.eventGaStepOneData.bool = false;
					// that.setValuesToNull(that.eventGaStepOneData);
				})
				.done(function () {
					that.preCartWarningCheckbox = false;
					that.precartWarning = false;
					that.eventGaStepOneData.bool = false;
					that.ticketType = '';
					that.loading = false;
					$('html,body').scrollTop(0);
					that.clearEventGaStepOneData();
				});
		},
		clearEventGaStepOneData() {
			this.eventGaStepOneData.bool = false;
			this.eventGaStepOneData.bool = null;
			this.eventGaStepOneData.date = null;
			this.eventGaStepOneData.day = null;
			this.eventGaStepOneData.eventId = null;
			this.eventGaStepOneData.month = null;
			this.eventGaStepOneData.priceTypes = null;
			this.eventGaStepOneData.pricesAdded = null;
			this.eventGaStepOneData.tickets = null;
			this.eventGaStepOneData.ticketsActive = null;
			this.eventGaStepOneData.ticketsAvailable = null;
			this.eventGaStepOneData.time = null;
			this.eventGaStepOneData.title = null;
			this.eventGaStepOneData.totalTickets = null;
			this.eventGaStepOneData.year = null;
			this.eventGaStepOneData.zoneId = null;
		},
		todayAndTomorrow() {
			const nextAvailableDates = this.findNextAvailableDates(this.daysNotOpen);
			this.nextAvailableDates = nextAvailableDates;
		},
		findNextAvailableDates(daysNotOpen) {
			// Get today's date
			let currentDate = new Date().setHours(0, 0, 0, 0);
			currentDate = new Date(currentDate);
			let nextAvailableDates = [];

			// Format the date
			let formattedDate = {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
			};
			let formattedDateStr = new Date(currentDate);

			if (
				currentDate.getDay() !== 2 &&
				currentDate.getDay() !== 3 &&
				!daysNotOpen.includes(currentDate.toISOString().split('T')[0])
			) {
				// Add the date to the result array
				nextAvailableDates.push({
					dayOfWeek: currentDate.toLocaleDateString('en-US', {
						weekday: 'long',
					}),
					formattedDate: currentDate.toLocaleDateString('en-US', formattedDate),
					formattedDateStr,
				});
			}

			while (nextAvailableDates.length < 2) {
				// Move to the next day

				currentDate.setDate(currentDate.getDate() + 1);
				// Check if the current day is not a Tuesday, Wednesday, or in the closedDates array
				if (
					currentDate.getDay() !== 2 &&
					currentDate.getDay() !== 3 &&
					!daysNotOpen.includes(currentDate.toISOString().split('T')[0])
				) {
					let formattedDateStr = new Date(currentDate);

					// Add the date to the result array
					nextAvailableDates.push({
						dayOfWeek: currentDate.toLocaleDateString('en-US', {
							weekday: 'long',
						}),
						formattedDate: currentDate.toLocaleDateString(
							'en-US',
							formattedDate
						),
						formattedDateStr,
					});
				}
			}
			return nextAvailableDates;
		},
		daysNotOpenFunction() {
			let splitDays = this.daysNotOpenProp.substring(
				0,
				this.daysNotOpenProp.length - 1
			);
			splitDays = splitDays.split(' ');
			let splitArray = [];
			let miniCalendarDates = [];
			splitDays.forEach((day) => {
				miniCalendarDates.push(new Date(day));
				let dayDate = new Date(day).toISOString().split('T')[0];
				splitArray.push(dayDate);
			});
			this.daysNotOpen = splitArray;
			this.vueDatepickerOptions[0].dates = miniCalendarDates;
		},
		async renderModal(event) {
			this.modalTicketsRendering = true;
			this.event = event;
			let date = new Date(event.start);
			event.month = this.monthNames[date.getMonth()];
			event.day = date.getDate();
			event.year = date.getFullYear();
			event.hours = date.getHours();
			event.minutes = date.getMinutes();
			this.singleTicketModalInfo = event;
			$('html,body').scrollTop(0);
			let that = this;
			try {
				const { data: jsonRes } = await axios.get(
					'/actions/my-module/default/event-pricetypes',
					{
						params: {
							tessId: event.extendedProps.tessId,
						},
					}
				);
				let jsonResFiltered = [];
				jsonRes.forEach((ticket) => {
					if (ticket.Enabled === true) {
						jsonResFiltered.push(ticket);
					}
				});
				that.eventTicketInfo = jsonResFiltered.map((pt) => ({
					pricetypeId: pt.PriceTypeId,
					price: pt.Price,
					count: 0,
					limit: 4,
				}));

				//   // use ticketids to get ticket text info
				let ptId = [];
				that.eventTicketInfo.forEach((ticket) => {
					ptId.push(ticket.pricetypeId);
				});
				let promises = [];

				promises.push(
					ptId.forEach((item, index) => {
						axios
							.get('/actions/my-module/default/event-pricetype-text', {
								params: {
									ticketId: item,
								},
							})
							.then(function (resp) {
								let response = resp.data;
								if (response[0]) {
									Vue.set(
										that.eventTicketInfo[index],
										'type',
										response[0].PriceType.Description
									);

									Vue.set(
										that.eventTicketInfo[index],
										'mos',
										response[0].ModeOfSale.Id
									);
								}

								if (!that.singleTicketModalInfo.extendedProps.gaRequired) {
									Vue.set(
										that.singleTicketModalInfo,
										'tickets',
										that.eventTicketInfo
									);
								} else {
									Vue.set(
										that.singleTicketModalInfo,
										'tickets',
										that.eventTicketInfo.filter((item) =>
											that.gaAllowedPriceTypes.includes(item.pricetypeId)
										)
									);
								}
							});
					})
				);
				await Promise.all(promises);
				that.modalTicketsRendering = false;
			} catch (error) {
				console.error(error);
				console.log('error');
			}
		},
		showYytTimes() {
			this.yytTimesBool = !this.yytTimesBool;
			if (this.yytTimesBool === false) {
				this.selectedYYtime = null;
			}
		},
		showRopesTimes() {
			this.ropesTimesBool = !this.ropesTimesBool;
			if (this.ropesTimesBool === false) {
				this.selectedRopesTime = null;
			}
		},
		processTickets(firstArray, secondArray) {
			let defaultTickets = [2, 11, 10, 152];
			let counter = 0;
			secondArray.forEach((secondObj) => {
				// Find the index of the matching id in the first array
				const index = firstArray.findIndex(
					(firstObj) => firstObj.id === secondObj.pricetypeId
				);
				if (index !== -1) {
					// Run addTicket number of times of the count value
					for (let i = 0; i < secondObj.count; i++) {
						this.addTicket('gaTickets', index);
					}
				}
			});
			secondArray.forEach((secondObj) => {
				if (!defaultTickets.includes(secondObj.pricetypeId)) {
					counter = counter + 1;
				}
			});
			if (counter === 0) {
				this.showLessTickets();
			}
			this.eventGaStepOneData.pricesAdded = false;
		},
		eventGaStepOne(index) {
			// set the tickets values
			this.getWidth();
			this.singleTicketModalInfo.tickets.forEach((obj) => {
				obj.limit = obj.count;
			});
			// save all the info needed to add item to cart
			this.eventGaStepOneData.ticketsAvailable =
				this.singleTicketModalInfo.extendedProps.ticketsAvail;
			this.eventGaStepOneData.eventId = this.singleTicketModalInfo.id;
			this.eventGaStepOneData.session = this.sessionKey;
			this.eventGaStepOneData.totalTickets = this.eventTotalTickets;
			this.eventGaStepOneData.priceTypes = this.eventPriceTypes;
			this.eventGaStepOneData.zoneId =
				this.singleTicketModalInfo.extendedProps.zone;
			this.eventGaStepOneData.month = this.singleTicketModalInfo.month;
			this.eventGaStepOneData.day = this.singleTicketModalInfo.day;
			this.eventGaStepOneData.year = this.singleTicketModalInfo.year;
			this.eventGaStepOneData.time =
				this.singleTicketModalInfo.extendedProps.time;
			this.eventGaStepOneData.tickets = this.eventTicketInfo;
			// this.eventGaStepOneData.allTickets = this.eventTicketInfo;

			this.eventGaStepOneData.date = this.singleTicketModalInfo.start;
			this.eventGaStepOneData.title = this.singleTicketModalInfo.title;
			this.eventGaStepOneData.bool = true;
			this.eventGaStepOneData.pricesAdded = true;
			this.eventGaStepOneData.ticketsActive =
				this.singleTicketModalInfo.tickets.filter((item) => item.count !== 0);

			// close the modal to clear things back to default screen
			this.closeSingleModal(index);
			this.ticketType = '';
			this.loading = false;
			$('html,body').scrollTop(0);
			// open the presets
			this.ticketType = 'general-admission';
			this.handleDateForGaEvent();
		},
		handleDateForGaEvent() {
			this.showMinical = true;
			this.date = this.eventGaStepOneData.date;
		},
		reserveRopesOnly(data) {
			let that = this;
			$.get(
				'/actions/my-module/default/reserve-event-tickets',
				{
					eventId: data.eventId,
					session: data.session,
					totalTickets: data.totalTickets,
					priceTypes: data.priceTypes,
					zoneId: data.zoneId,
				},
				function (res) {
					let jsonRes = JSON.parse(res);
				}
			)
				.done(function () {
					$.get(
						'/actions/my-module/default/get-cart-details',
						{ session: that.sessionKey },
						function (res) {
							let jsonData = JSON.parse(res);
							that.cartData = jsonData;
							if (that.mobile && that.cartData) {
								that.ticketAdded = true;
							}
						}
					);
				})
				.done(function () {
					that.ticketType = '';
					that.loading = false;
					$('html,body').scrollTop(0);
				});
		},
		reserveEventTickets(index) {
			this.loading = true;
			let that = this;
			$.get(
				'/actions/my-module/default/reserve-event-tickets',
				{
					eventId: that.singleTicketModalInfo.id,
					session: that.sessionKey,
					totalTickets: that.eventTotalTickets,
					priceTypes: that.eventPriceTypes,
					zoneId: that.singleTicketModalInfo.extendedProps.zone,
				},
				function (res) {
					let jsonRes = JSON.parse(res);
					Vue.set(that.event, 'lineItemId', jsonRes.LineItemId);
				}
			)
				.done(function () {
					$.get(
						'/actions/my-module/default/get-cart-details',
						{ session: that.sessionKey },
						function (res) {
							let jsonData = JSON.parse(res);
							that.cartData = jsonData;
							if (that.mobile && that.cartData) {
								that.ticketAdded = true;
							}
						}
					);
				})
				.done(function () {
					let cartObj = {
						event: that.event,
					};
					that.cart.push(cartObj);
					let inFifteenMinutes = new Date(
						new Date().getTime() + 20 * 60 * 1000
					);

					inFifteenMinutes = inFifteenMinutes.toUTCString();
					that.$cookies.set(that.sessionKey, JSON.stringify(that.cart), {
						expires: inFifteenMinutes,
					});
					let sessionCookie = that.$cookies.get(that.sessionKey);
				})
				.done(function () {
					that.closeSingleModal(index);
					that.ticketType = '';
					that.loading = false;
					$('html,body').scrollTop(0);
				});
		},
		cartEditSetLoading(bool) {
			this.loading = bool;
		},
		addEventTicket(index) {
			if (
				this.singleTicketModalInfo.tickets[index].count ===
					this.singleTicketModalInfo.tickets[index].limit ||
				this.singleTicketModalInfo.tickets[index].count ===
					this.singleTicketModalInfo.tickets[index].ticketsAvail ||
				this.singleTicketModalInfo.extendedProps.ticketsAvail ===
					this.eventTotalTickets
			) {
				return;
			}
			this.singleTicketModalInfo.tickets[index].count += 1;

			// get total amount of tickets
			let tCounter = 0;
			this.singleTicketModalInfo.tickets.forEach((amount) => {
				tCounter += amount.count;
			});
			this.eventTotalTickets = tCounter;
			this.adjustEventPricetypes();
		},
		removeEventTicket(index) {
			if (this.singleTicketModalInfo.tickets[index].count > 0) {
				this.singleTicketModalInfo.tickets[index].count -= 1;

				// get total amount of tickets
				let tCounter = 0;
				this.singleTicketModalInfo.tickets.forEach((amount) => {
					tCounter += amount.count;
				});
				this.eventTotalTickets = tCounter;
				this.adjustEventPricetypes();
			}
		},
		removeParameterFromURL(parameterName) {
			var currentURL = window.location.href;
			var searchParams = new URLSearchParams(window.location.search);

			if (searchParams.has(parameterName)) {
				searchParams.delete(parameterName);
				var newURL = currentURL.split('?')[0] + '?' + searchParams.toString();
				history.replaceState(null, null, newURL);
			}
		},
		closeSingleModal(index) {
			this.removeParameterFromURL('id');
			this.singleTicketModalInfo = null;
			this.noModal = true;
			this.eventModalIndex = index;
			this.eventTotalTickets = null;
			this.eventPriceTypes = null;
		},
		adjustEventPricetypes() {
			this.eventPriceTypes = '';
			let newStr = '';
			this.singleTicketModalInfo.tickets.forEach((ticket) => {
				if (ticket.count > 0) {
					let str = ticket.pricetypeId;
					str = str.toString() + ',';
					newStr += str.repeat(ticket.count);
					this.eventPriceTypes = newStr.slice(0, -1);
				}
			});
		},
		updateCart(jsonData) {
			this.cartData = jsonData;
		},
		closeMinical() {
			this.showMinical = false;
		},
		updatePackage(packageToEdit) {
			this.ticketType = 'general-admission';
			this.date = packageToEdit[0].date;
			if (
				packageToEdit[0].date !== this.firstDatePicker ||
				packageToEdit[0].date !== this.secondDatePicker
			) {
				this.showMinical = true;
			}
			if (this.mobile) {
				this.ticketAdded = false;
			}
		},
		cookieCartEventUpdate(lineItemId) {
			let cookieCart = this.$cookies.get(this.sessionKey);
			cookieCart = cookieCart.filter(function (item) {
				if (item.event) {
					return item.event.lineItemId !== lineItemId;
				} else {
					return item;
				}
			});
			let inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
			inFifteenMinutes = inFifteenMinutes.toUTCString();
			this.$cookies.set(this.sessionKey, JSON.stringify(cookieCart), {
				expires: inFifteenMinutes,
			});
			this.cart = cookieCart;
		},
		cookieCartUpdate(lineItemId) {
			let cookieCart = this.$cookies.get(this.sessionKey);
			cookieCart = cookieCart.filter(function (item) {
				return item.nfsPackageLineItemId !== lineItemId;
			});
			let inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
			inFifteenMinutes = inFifteenMinutes.toUTCString();
			this.$cookies.set(this.sessionKey, JSON.stringify(cookieCart), {
				expires: inFifteenMinutes,
			});
			this.cart = cookieCart;
		},
		showMoreTickets() {
			this.gaTicketsRendered = this.gaTickets;
			this.showLess = true;
		},
		showLessTickets() {
			this.gaTicketsRendered = this.gaTickets.slice(0, 4);
			this.gaTickets.forEach((ticket, index) => {
				if (index >= 4) {
					ticket.count = 0;
				}
			});
			this.adjustPricetypes();
			this.showLess = false;
		},
		openCart() {
			this.ticketAdded = true;
		},
		setTicketType(type) {
			this.ticketType = type;
		},
		setDate(date) {
			if (date) {
				this.date = date;
			}
		},
		validatePromo() {
			if (this.promoCode === '' || this.promoCode === null) {
				return;
			}
			let that = this;
			if (that.sourceId !== null) {
				return;
			}
			$.get(
				'/actions/my-module/default/validate-promo',
				{
					session: that.sessionKey,
					promo: that.promoCode,
				},
				function (res) {
					let jsonRes = JSON.parse(res);

					if (jsonRes.length === 0) {
						return (that.promoError = true);
					}
					that.loading = true;
					that.promoLoading = true;
					that.sourceId = jsonRes[0].Source.Id;
					that.appealId = jsonRes[0].Source.Appeal.Id;
				}
			).done(function () {
				if (that.promoError === true) {
					return;
				}
				$.get(
					'/actions/my-module/default/get-promo-id',
					{ date: that.formattedDate },
					function (res) {
						let jsonRes = JSON.parse(res);
						jsonRes = jsonRes.filter(
							(pack) => pack.PackageDescription === 'Museum Admission'
						);
						that.promoId = jsonRes[0].PackageId;
						that.$nextTick();
					}
				);
			});
		},
		removePromo() {
			this.gaRenderedPriceTypes.shift();
			this.gaAllowedPriceTypes.shift();
			$('.tLeft__promoInput').val('Enter Promo Code');
			this.sourceId = null;
			this.appealId = null;
			this.promoCode = '';
			this.$nextTick();
		},
		settingYYtime(index) {
			this.selectedYYtime = this.yyTimes[index].id;
		},
		settingRopesTime(index) {
			this.selectedRopesTime = this.ropesTimes[index].id;
		},
		removeTicket(string, index) {
			this.eventGaTicketWarning = false;
			this.eventGaTicketWarningText = '';
			this.eventGaOutOfTickets = '';
			if (string === 'gaTickets') {
				if (this.gaTickets[index].count > 0) {
					this.gaTickets[index].count -= 1;

					// get total amount of tickets
					let tCounter = 0;
					this.gaTickets.forEach((amount) => {
						tCounter += amount.count;
					});
					this.totalGaTickets = tCounter;
					this.adjustPricetypes('ga');
				}
			} else if (string === 'gaEvents') {
				if (this.eventGaStepOneData.ticketsActive[index].count > 0) {
					this.eventGaStepOneData.ticketsActive[index].count -= 1;

					// get total amount of tickets
					let tCounter = 0;
					this.eventGaStepOneData.ticketsActive.forEach((amount) => {
						tCounter += amount.count;
					});
					this.eventGaStepOneData.totalTickets = tCounter;
					this.adjustPricetypes('event');
				}
			}
		},
		adjustPricetypes(string) {
			if (string === 'ga') {
				this.priceTypes = '';
				let newStr = '';
				this.gaTickets.forEach((ticket) => {
					if (ticket.count > 0) {
						let str = ticket.id;
						str = str.toString() + ',';
						newStr += str.repeat(ticket.count);
						this.priceTypes = newStr.slice(0, -1);
					}
				});
			} else if (string === 'event') {
				this.eventGaStepOneData.priceTypes = '';
				let newStr = '';
				this.eventGaStepOneData.ticketsActive.forEach((ticket) => {
					if (ticket.count > 0) {
						let str = ticket.pricetypeId;
						str = str.toString() + ',';
						newStr += str.repeat(ticket.count);
						this.eventGaStepOneData.priceTypes = newStr.slice(0, -1);
					}
				});
			}
		},
		eventGaTicketNoticifation(string, object, objectTwo) {
			if (string === 'moreGaTickets') {
				this.eventGaTicketWarning = true;
				this.eventGaTicketWarningText = object.type;
				this.eventGaOutOfTickets = '';
			}
			if (string === 'outOfTickets') {
				this.eventGaTicketWarning = true;
				this.eventGaTicketWarningText = '';
				this.eventGaOutOfTickets = objectTwo.totalTickets;
			}
		},
		addTicket(string, index) {
			this.eventGaTicketWarning = false;
			this.eventGaTicketWarningText = '';
			this.eventGaOutOfTickets = '';
			if (string === 'gaTickets') {
				if (this.gaTickets[index].count === this.gaTickets[index].limit) {
					return;
				}
				this.gaTickets[index].count += 1;

				// get total amount of tickets
				let tCounter = 0;
				this.gaTickets.forEach((amount) => {
					tCounter += amount.count;
				});
				this.totalGaTickets = tCounter;
				this.adjustPricetypes('ga');
			} else if (string === 'gaEvents') {
				// handle 'out of tickets'
				if (
					this.eventGaStepOneData.totalTickets ===
					this.eventGaStepOneData.ticketsAvailable
				) {
					return this.eventGaTicketNoticifation(
						'outOfTickets',
						null,
						this.eventGaStepOneData
					);
				}
				// handle ticket limit based on ga tickets

				if (
					this.eventGaStepOneData.ticketsActive[index].count ===
					this.eventGaStepOneData.ticketsActive[index].limit
				) {
					return this.eventGaTicketNoticifation(
						'moreGaTickets',
						this.eventGaStepOneData.ticketsActive[index],
						''
					);
				}

				this.eventGaStepOneData.ticketsActive[index].count += 1;

				// get total amount of tickets
				let tCounter = 0;
				this.eventGaStepOneData.ticketsActive.forEach((amount) => {
					tCounter += amount.count;
				});
				this.eventGaStepOneData.totalTickets = tCounter;
				this.adjustPricetypes('event');
			}
		},
		closeGaPackageNotice() {
			this.gaPackageNoticeInfo = null;
		},
		addGaTicketsToCartReset() {
			this.gaTicketsRendered = null;
			this.nfsPackageLineItemId = null;
			this.ticketType = '';
			this.date = '';
			this.gaPerformanceId = null;
			this.gaPackageId = null;
			this.gaZoneId = null;
			this.gaPerformanceGroupId = null;
			this.yytPerformanceGroupId = null;
			this.yytPerformanceId = null;
			this.yytAllZones = null;
			this.ropesPerformanceGroupId = null;
			this.ropesPerformanceId = null;
			this.ropesAllZones = null;
			this.priceTypes = null;
			this.promoCode = '';
			this.promoCodeValidated = false;
			this.selectedYYtime = null;
			this.selectedRopesTime = null;
			this.totalGaTickets = null;
			this.showMinical = false;
			this.showLess = false;
			this.gaTickets = null;
			this.yyTimes = null;
			this.ropesTimes = null;
			this.gaRenderedPriceTypes = null;
			this.gaTicketTextInfo = null;
			this.yytTimesBool = false;
			this.ropesTimesBool = false;
			this.ticketAdded = true;
			$('html,body').scrollTop(0);
		},
		removeEventWithGa() {
			let products = this.cartData.Products;
			let perfToRemove =
				products.find(
					(obj) =>
						obj.Performance.PerformanceId === this.eventGaStepOneData.eventId
				) || null;

			let perfId = perfToRemove.Performance.PerformanceId;
			let lineItemId = perfToRemove.Performance.LineItemId;
			this.$emit('removePerformanceId', perfId, lineItemId, false);
			this.precartAdded();
		},
		addGaTicketsToCart() {
			let that = this;
			// General Admission Call
			$('html,body').scrollTop(0);
			that.loading = true;
			$.get(
				'/actions/my-module/default/add-general-admission',
				{
					session: this.sessionKey,
					totalGaTickets: this.totalGaTickets,
					packageId: this.gaPackageId,
					performanceId: this.gaPerformanceId,
					performanceGroupId: this.gaPerformanceGroupId,
					priceTypes: this.priceTypes,
					zoneId: this.gaZoneId,
				},
				function (res) {
					let jsonRes = JSON.parse(res);
					that.nfsPackageLineItemId = jsonRes.NFSPackageLineItemId;
				}
			)
				.done(function () {
					if (that.selectedYYtime === null || that.selectedYYtime === 0) {
						return;
					} else {
						$.get(
							'/actions/my-module/default/add-yyt-admission',
							{
								nfsPackageLineItemId: that.nfsPackageLineItemId,
								session: that.sessionKey,
								totalGaTickets: that.totalGaTickets,
								packageId: that.gaPackageId,
								performanceId: that.yytPerformanceId,
								performanceGroupId: that.yytPerformanceGroupId,
								priceTypes: that.priceTypes,
								zoneId: that.selectedYYtime,
							},
							function (res) {}
						);
					}
				})
				.done(function () {
					// For ropes mansion
					if (that.selectedRopesTime === null || that.selectedRopesTime === 0) {
						return;
					} else {
						$.get(
							'/actions/my-module/default/add-yyt-admission',
							{
								nfsPackageLineItemId: that.nfsPackageLineItemId,
								session: that.sessionKey,
								totalGaTickets: that.totalGaTickets,
								packageId: that.gaPackageId,
								performanceId: that.ropesPerformanceId,
								performanceGroupId: that.ropesPerformanceGroupId,
								priceTypes: that.ropesPriceTypes,
								zoneId: that.selectedRopesTime,
							},
							function (res) {
								console.log('in');
							}
						);
					}
				})
				.done(function () {
					if (that.eventGaStepOneData.totalTickets > 0) {
						if (
							that.eventGaStepOneData.date &&
							that.eventGaStepOneData.date.split('T')[0] === that.formattedDate
						) {
							that.precartAdded();
							that.clearEventGaStepOneData();
						}
					}
				})
				.done(function () {
					$.get(
						'/actions/my-module/default/get-cart-details',
						{ session: that.sessionKey },
						function (res) {
							let jsonData = JSON.parse(res);
							that.cartData = jsonData;
						}
					);
				})
				.done(function () {
					let cartObj = {
						nfsPackageLineItemId: that.nfsPackageLineItemId,
						date: that.date,
					};

					if (
						that.ropesPerformanceId !== null &&
						that.ropesPerformanceGroupId !== null &&
						that.selectedRopesTime !== null
					) {
						cartObj.ropesPerformanceGroupId = that.ropesPerformanceGroupId;
						cartObj.ropesPerformanceId = that.ropesPerformanceId;
						cartObj.ropesZone = that.selectedRopesTime;
					}

					that.cart.push(cartObj);
				})
				.done(function () {
					let inFifteenMinutes = new Date(
						new Date().getTime() + 15 * 60 * 1000
					);
					inFifteenMinutes = inFifteenMinutes.toUTCString();
					that.$cookies.set(that.sessionKey, JSON.stringify(that.cart), {
						expires: inFifteenMinutes,
						path: '/',
					});
					that.addGaTicketsToCartReset();
					that.loading = false;
				});
		},
		searchPackageByDate() {
			let that = this;
			this.loading = true;
			$.get(
				'/actions/my-module/default/search-date-for-package-id',
				{ date: that.formattedDate },
				function (res) {
					let jsonRes = JSON.parse(res);
					jsonRes = jsonRes.filter(
						(pack) => pack.PackageDescription === 'Museum Admission'
					);
					that.gaPackageId = jsonRes[0].PackageId;
				}
			);
		},
		searchPackageById() {
			let that = this;
			$.get(
				'/actions/my-module/default/search-id-for-package-info',
				{ packageId: this.gaPackageId },
				function (res) {
					let jsonRes = JSON.parse(res);
					// Notice for date selection
					if (
						jsonRes.PerformanceGroupDetails[0]
							.PerformanceGroupPerformanceDetails[0].SalesNotes
					) {
						that.gaPackageNoticeInfo =
							jsonRes.PerformanceGroupDetails[0].PerformanceGroupPerformanceDetails[0].SalesNotes;
					}

					// **** General Admission info ****
					that.gaPerformanceId =
						jsonRes.PerformanceGroupDetails[0].PerformanceGroupPerformanceDetails[0].PerformanceId;
					that.gaZoneId =
						jsonRes.PerformanceGroupDetails[0].PerformanceGroupPerformanceDetails[0].Zones[0].Zone.Id;
					that.gaPerformanceGroupId = jsonRes.PerformanceGroupDetails[0].Id;
					// **** Yin Yu Tang Info needed ****
					let packageLength = jsonRes.PerformanceGroupDetails.length;

					if (
						packageLength > 1 &&
						jsonRes.PerformanceGroupDetails[1].Description[0] === 'Y'
					) {
						that.yytPerformanceGroupId = jsonRes.PerformanceGroupDetails[1].Id;
						that.yytPerformanceId =
							jsonRes.PerformanceGroupDetails[1].PerformanceGroupPerformanceDetails[0].PerformanceId;
						let yyZones =
							jsonRes.PerformanceGroupDetails[1]
								.PerformanceGroupPerformanceDetails[0].Zones;
						that.yytAllZones = yyZones.filter(
							(zone) => zone.AvailableCount > 0
						);
					} else if (
						packageLength > 1 &&
						jsonRes.PerformanceGroupDetails[1].Description[0] === 'R'
					) {
						that.ropesPerformanceGroupId =
							jsonRes.PerformanceGroupDetails[1].Id;
						that.ropesPerformanceId =
							jsonRes.PerformanceGroupDetails[1].PerformanceGroupPerformanceDetails[0].PerformanceId;
						that.ropesAllZones =
							jsonRes.PerformanceGroupDetails[1].PerformanceGroupPerformanceDetails[0].Zones.filter(
								(zone) => zone.AvailableCount > 0
							);
					}
					if (
						jsonRes.PerformanceGroupDetails.length > 2 &&
						jsonRes.PerformanceGroupDetails[2].Description[0] === 'R'
					) {
						that.ropesPerformanceGroupId =
							jsonRes.PerformanceGroupDetails[2].Id;
						that.ropesPerformanceId =
							jsonRes.PerformanceGroupDetails[2].PerformanceGroupPerformanceDetails[0].PerformanceId;
						that.ropesAllZones =
							jsonRes.PerformanceGroupDetails[2].PerformanceGroupPerformanceDetails[0].Zones.filter(
								(zone) => zone.AvailableCount > 0
							);
					}
				}
			);
		},

		getPriceTypes() {
			let that = this;
			$.get(
				'/actions/my-module/default/get-all-price-types',
				{ gaPerformanceId: this.gaPerformanceId },
				function (res) {
					let jsonRes = JSON.parse(res);
					let filteredPriceTypes = jsonRes;

					// filter All price types numerical info (ids) by the allowed pricetypes array
					// let filteredPriceTypes = [];
					filteredPriceTypes = filteredPriceTypes.filter(
						(item) => that.gaAllowedPriceTypes.indexOf(item.PriceTypeId) !== -1
					);

					// use filtered price types to create array of objects with the info for the tickets and create array of objects with the info
					let gaRenderedPriceTypes = [];
					let limitTen = [2, 11, 10, 152, 6, 7, 9, 85];
					let limitOne = [126, 118, 130, 134, 135, 137, 138, 140];
					filteredPriceTypes.forEach((price) => {
						if (limitTen.includes(price.PriceTypeId)) {
							gaRenderedPriceTypes.push({
								limit: 10,
								id: price.PriceTypeId,
								count: 0,
								price: price.PerformancePrices[0].Price,
								zoneId: price.PerformancePrices[0].ZoneId,
							});
						} else if (price.PriceTypeId === 129) {
							gaRenderedPriceTypes.push({
								limit: 4,
								id: price.PriceTypeId,
								count: 0,
								price: price.PerformancePrices[0].Price,
								zoneId: price.PerformancePrices[0].ZoneId,
							});
						} else if (price.PriceTypeId === 125) {
							gaRenderedPriceTypes.push({
								limit: 6,
								id: price.PriceTypeId,
								count: 0,
								price: price.PerformancePrices[0].Price,
								zoneId: price.PerformancePrices[0].ZoneId,
							});
						} else if (limitOne.includes(price.PriceTypeId)) {
							gaRenderedPriceTypes.push({
								limit: 1,
								id: price.PriceTypeId,
								count: 0,
								price: price.PerformancePrices[0].Price,
								zoneId: price.PerformancePrices[0].ZoneId,
							});
						} else {
							gaRenderedPriceTypes.push({
								limit: 2,
								id: price.PriceTypeId,
								count: 0,
								price: price.PerformancePrices[0].Price,
								zoneId: price.PerformancePrices[0].ZoneId,
								eventTotal: 0,
							});
						}
					});
					that.gaRenderedPriceTypes = gaRenderedPriceTypes;
				}
			);
		},
		getGaTicketText() {
			let that = this;
			$.get('/actions/my-module/default/get-ga-ticket-text', function (res) {
				let jsonRes = JSON.parse(res);

				// filter All price type text info price types by the allowed pricetypes array and create array of objects with the info
				let filteredText = [];
				filteredText = jsonRes.filter(
					(item) => that.gaAllowedPriceTypes.indexOf(item.Id) !== -1
				);
				let filteredArray = [];
				filteredText.forEach((price) => {
					filteredArray.push({
						id: price.Id,
						title: price.Description,
						helperText: price.AliasDescription,
					});
				});
				that.gaTicketTextInfo = filteredArray;
			});
		},
		getGaTickets() {
			// merge the two arrays to get ticket info
			let mergedTicketInfo = this.gaRenderedPriceTypes.map((t1) => ({
				...t1,
				...this.gaTicketTextInfo.find((t2) => t2.id === t1.id),
			}));

			// sort the merged array according to the preferred order - this.gaAllowedPriceTypes
			mergedTicketInfo = this.gaAllowedPriceTypes.map((i) =>
				mergedTicketInfo.find((j) => j.id === i)
			);
			// set gaTickets and gaTicketsRendered to the sorted array of ticket type objects
			this.gaTickets = mergedTicketInfo;
			this.gaTicketsRendered = mergedTicketInfo.slice(0, 4);
			this.loading = false;
		},
		yytTicketsAllowed() {
			if (!this.yytAllZones) {
				return;
			}
			// filter times if ticket count is higher than the totalGaTicket Count
			let zones = this.yytAllZones.filter(
				(zone) => zone.AvailableCount >= this.totalGaTickets
			);
			let testDate = new Date(this.date);
			testDate = new Date(testDate.setTime);
			// Loop YYT times to create an array of objects with data needed for use to populate the YYT selections = this.yyTimes
			let zoneArr = [
				{
					id: 0,
					performanceId: 0,
					availableCount: 10000,
					presentationTime: 'Opt Out',
					time: null,
				},
			];
			zones.forEach((zone) => {
				let testDateTime = new Date(this.date);
				let hours = parseInt(zone.Zone.ZoneTime.slice(0, 2));
				let minutes = parseInt(zone.Zone.ZoneTime.slice(3, 5));
				let seconds = parseInt(zone.Zone.ZoneTime.slice(6, 8));
				let zoneTime = testDateTime.setHours(hours, minutes, seconds);
				let nowTime = new Date();
				if (zoneTime > nowTime) {
					zoneArr.push({
						id: zone.Zone.Id,
						performanceId: zone.PerformanceId,
						availableCount: zone.AvailableCount,
						presentationTime: zone.Zone.Description.toLowerCase(),
						time: zone.Zone.ZoneTime,
					});
				}
			});
			this.yyTimes = zoneArr;
		},
		ropesTicketsAllowed() {
			if (!this.ropesAllZones) {
				return;
			}

			// filter times if ticket count is higher than the totalGaTicket Count
			let zones = this.ropesAllZones.filter(
				(zone) => zone.AvailableCount >= this.totalGaTickets
			);
			let testDate = new Date(this.date);
			testDate = new Date(testDate.setTime);
			// Loop ropes times to create an array of objects with data needed for use to populate the YYT selections = this.ropesTimes
			let zoneArr = [
				{
					id: 0,
					performanceId: 0,
					availableCount: 10000,
					presentationTime: 'Opt Out',
					time: null,
				},
			];
			zones.forEach((zone) => {
				let testDateTime = new Date(this.date);
				let hours = parseInt(zone.Zone.ZoneTime.slice(0, 2));
				let minutes = parseInt(zone.Zone.ZoneTime.slice(3, 5));
				let seconds = parseInt(zone.Zone.ZoneTime.slice(6, 8));
				let zoneTime = testDateTime.setHours(hours, minutes, seconds);
				let nowTime = new Date();
				if (zoneTime > nowTime) {
					zoneArr.push({
						id: zone.Zone.Id,
						performanceId: zone.PerformanceId,
						availableCount: zone.AvailableCount,
						presentationTime: zone.Zone.Description.toLowerCase(),
						time: zone.Zone.ZoneTime,
					});
				}
			});
			this.ropesTimes = zoneArr;
		},
		resetOnDateSelection() {
			this.ropesPerformanceGroupId = null;
			this.ropesPerformanceId = null;
			this.ropesAllZones = null;
			this.ropesTimes = null;
			this.selectedRopesTime = null;
			this.selectedYYtime = null;
			this.yytPerformanceGroupId = null;
			this.yytPerformanceId = null;
			this.yytAllZones = null;
			this.yyTimes = null;
			this.priceTypes = null;
			this.totalGaTickets = null;
			this.gaTickets = null;
			this.gaTicketsRendered = null;
			this.gaRenderedPriceTypes = null;
			this.gaPackageId = null;
			this.gaPerformanceId = null;
			this.gaPerformanceGroupId = null;
		},
		getWidth() {
			let width = window.innerWidth;
			if (width <= 768) {
				this.mobile = true;
			} else {
				this.mobile = false;
			}
		},
		useTargetType(targetType, targetDate) {
			if (targetType === 'ga') {
				this.ticketType = 'general-admission';
				this.showMinical = true;
				let date = new Date(targetDate);
				if (targetDate) {
					let newDate = targetDate + 'T10:00:00Z';
					newDate.toLocaleString('en-US', { timeZone: 'America/New_York' });
					this.date = new Date(newDate);
				}
			} else if (targetType === 'tour') {
				this.ticketType = 'tour';
			}
			// after params have been used, remove them so they don't cause wonkiness
			setTimeout(() => {
				this.removeParameterFromURL('type');
				this.removeParameterFromURL('date');
			}, '3500');
		},
		useTargetId(targetId) {
			this.ticketType = 'programs';
		},
		falseTicketAdded() {
			this.ticketAdded = false;
		},
		handleEventGaTickets(current) {
			let ticketsWithCount = [];
			let ticketsWithCountObjects = [];
			let ticketsWithoutCount = [];

			this.gaTickets.forEach((tick) => {
				if (tick.count > 0) {
					ticketsWithCount.push(tick.id);
					ticketsWithCountObjects.push(tick);
				} else {
					ticketsWithoutCount.push(tick.id);
				}
			});
			// handle tickets with count
			ticketsWithCount.forEach((number, index) => {
				// check each number to see if the pricetype is already in the active tickets array
				const match = this.eventGaStepOneData.ticketsActive.find(
					(obj) => obj.pricetypeId === number
				);
				if (match) {
					// update the already active prictypes limit to match the ga ticket's count
					match.limit = ticketsWithCountObjects[index].count;
					// if the count if over the limit, regulate the count
					if (match.count > match.limit) {
						match.count = match.limit;
					}
					return;
				} else {
					// else check to see if the ticket type for that event exists in the all tickets array
					const match2 = this.eventGaStepOneData.tickets.find(
						(obj) => obj.pricetypeId === number
					);
					if (match2) {
						// if it does, set the ticket's limit value to the ga ticket's count value
						const matchGaTicket = this.gaTickets.find(
							(obj) => obj.id === number
						);
						match2.limit = matchGaTicket.count;
						// then push that ticket into the active tickets array
						this.eventGaStepOneData.ticketsActive.push(match2);
					} else {
						return;
					}
				}
			});

			// handle tickets without count
			this.eventGaStepOneData.ticketsActive =
				this.eventGaStepOneData.ticketsActive.filter(
					(obj) => !ticketsWithoutCount.includes(obj.pricetypeId)
				);
		},
	},
	watch: {
		promoId(promo) {
			if (promo === null) {
				return;
			}
			let jsonRes = null;
			let that = this;
			$.get(
				'/actions/my-module/default/mode-of-sale-offers',
				{
					promoId: promo,
				},
				function (res) {
					let jsonRes = JSON.parse(res);
					jsonRes = jsonRes.filter(
						(resItem) =>
							resItem.SourceId === that.sourceId &&
							resItem.AppealId === that.appealId
					);
					that.gaAllowedPriceTypes.unshift(jsonRes[0].PriceTypeId);
					that.promoLoading = false;
				}
			);
			that.promoId = null;
			that.loading = false;
			that.priceTypes = null;
			that.totalGaTickets = null;
			that.promoCode = '';
			that.selectedYYtime = null;
			that.$nextTick();
		},
		gaAllowedPriceTypes(newPricetypes) {
			if (newPricetypes === [2, 11, 10, 152, 6, 7, 9, 129]) {
				return;
			}
			this.getPriceTypes();
		},
		formattedDate(date) {
			if (date === null || date === '') {
				return '';
			}
			this.resetOnDateSelection();
			this.searchPackageByDate();
		},
		gaPackageId(newId) {
			if (!newId) {
				return;
			}
			this.searchPackageById();
		},
		gaPerformanceId(newId) {
			if (!newId) {
				return;
			}
			this.getPriceTypes();
		},
		gaRenderedPriceTypes(newPrices) {
			if (!newPrices) {
				return;
			}
			this.getGaTicketText();
		},
		gaTicketTextInfo(newPrices) {
			if (!newPrices) {
				return;
			}
			this.getGaTickets();
		},
		priceTypes(val) {
			if (val === '' || val == null) {
				return (this.ropesPriceTypes = null);
			}
			this.ropesPriceTypes = val
				.split(',')
				.map((num) => {
					const fiveDollarPrices = ['2', '6', '7', '159', '67', '118'];
					return fiveDollarPrices.includes(num.trim()) ? '197' : '198';
				})
				.join(',');
		},
		promoCode(promo) {
			this.promoError = false;
		},
		totalGaTickets(countNew) {
			if (countNew < 0) {
				return;
			}
			this.yytTicketsAllowed();
			if (this.ropesAllZones !== null) {
				this.ropesTicketsAllowed();
			}
			this.updateDropDownValues(countNew);
		},
		ticketType() {
			if (this.ticketType === 'general-admission') {
				if (!this.eventGaStepOneData.bool) {
					setTimeout(() => {
						this.$refs['step2'].scrollIntoView({ behavior: 'smooth' });
					}, '500');
				}
			} else {
				this.date = '';
				this.showMinical = false;
				this.resetOnDateSelection();
			}
		},
		gaTickets: {
			handler(current, old) {
				if (this.gaTickets === null) {
					return;
				} else if (this.eventGaStepOneData.tickets !== null) {
					this.handleEventGaTickets(current);
				}
			},
			deep: true,
		},
		cartData: {
			handler(current, old) {
				if (
					(!this.cartData && !this.cartData.Products) ||
					(this.cartData && !this.cartData.Products)
				) {
					this.ticketAdded = false;
					return;
				}
			},
			deep: true,
		},
		gaTicketsRendered() {
			if (this.gaTicketsRendered !== null) {
				if (
					this.eventGaStepOneData.pricesAdded == true &&
					this.gaRenderedPriceTypes
				) {
					this.showMoreTickets();
					this.processTickets(
						this.gaTicketsRendered,
						this.eventGaStepOneData.tickets
					);
				}
				if (!this.eventGaStepOneData.bool) {
					setTimeout(() => {
						this.$refs['step3'].scrollIntoView({ behavior: 'smooth' });
					}, '500');
				}
			}
		},
		daysNotOpen() {
			if (this.daysNotOpen.length === 0) {
				return;
			}
			this.todayAndTomorrow();
		},
	},
	beforeMount() {
		const windowLocation = window.location.search;
		const urlParams = new URLSearchParams(windowLocation);
		const session = urlParams.get('session');
		const targetId = urlParams.get('id');
		const targetDate = urlParams.get('date');
		const targetType = urlParams.get('type');
		if (!session) {
			window.location.replace('https://www.pem.org/gettickets');
		}
		this.sessionKey = session;
		let sessionCookie = this.$cookies.get(this.sessionKey);
		this.daysNotOpenFunction();
		this.getWidth();
		let that = this;
		if (sessionCookie || this.sessionKey) {
			$.get(
				'/actions/my-module/default/get-cart-details',
				{ session: that.sessionKey },
				function (res) {
					let jsonData = JSON.parse(res);
					that.cartData = jsonData;
					if (jsonData === null) {
						that.cart = [];
					} else {
						that.cart = sessionCookie;
						that.ticketAdded = true;
					}
					that.loading = false;
				}
			);
		} else {
			console.log('no cookie');
		}
		if (targetId) {
			this.useTargetId(targetId);
		}
		if (targetDate && targetType) {
			this.useTargetType(targetType, targetDate);
		}
	},
	mounted() {
		let that = this;
		jQuery(document).ready(function ($) {
			$(window).resize(function () {
				that.getWidth();
			});
		});
	},
};
</script>
